import {useDispatch, useSelector} from "react-redux";
import {tryLoadBlogs, tryLoadTags} from "../../redux/slices/manageBlogSlice";
import Paginator from "../../components/Paginator";
import {BLOG_TAB_TAGS} from "./constants";

export default function BlogsPaginator() {
  const selectedTab = useSelector((state) => state.manageBlogs.selectedTab);

  const {page, totalPages} = useSelector((state) => state.manageBlogs[selectedTab].meta)

  const {
    loading = false, init = false, error

  } = useSelector((state) => state.manageBlogs[selectedTab].pageData[page]) ?? {};


  const dispatch = useDispatch();

  const onPagesClick = (page) => {
    dispatch(tryLoadBlogs({page}));
  };


  return (
    <>
      {!error &&
      <Paginator currentPage={page} totalPages={totalPages} onClick={onPagesClick}
               loading={!init || loading}/>}
    </>
  );
}

export function TagsPaginator() {

  const {page, totalPages} = useSelector((state) => state.manageBlogs[BLOG_TAB_TAGS].meta)

  const {
    loading = false, init = false, error

  } = useSelector((state) => state.manageBlogs[BLOG_TAB_TAGS].pageData[page]) ?? {};


  const dispatch = useDispatch();

  const onPagesClick = (page) => {
    dispatch(tryLoadTags({page, type: BLOG_TAB_TAGS}));
  };


  return (
    <>
      {!error &&
        <Paginator currentPage={page} totalPages={totalPages} onClick={onPagesClick}
                   loading={!init || loading}/>}
    </>
  );
}

